<template>
  <div :class="`position-relative h-100 my-3`">
    <p style="display:none">{{ getIdItinerary }}</p>
    <div class="mx-4 py-3 px-4 signature" v-if="signature.id">
      <p class="mx-0 my-0 fw-600">
        <span style="color: rgb(193, 50, 62);">Signed by: </span>
        <span class="text-main"
          >{{ signature.name }}, {{ signature.local_datetime }} </span
        >
      </p>
      <div class="actions" style="display:none;">
        <button
          :disabled="this.isSearching"
          type="button"
          data-toggle="tooltip"
          title="Print from browser"
          class="btn btn-md btn-secondary py-2"
          @click="handleEditSignature"
        >
          <font-awesome-icon :icon="['fas', 'check']" />
          &nbsp; Save new info
        </button>
      </div>
    </div>
    <template>
      <div class="mx-4 px-4 py-4 signature-edit">
        <div class="row">
          <div class="col">
            <label class="fw-500">Full Name</label>
            <input
              disabled
              type="text"
              class="form-control"
              placeholder="Full Name"
              v-model="signature.name"

            />
          </div>
          <div class="col">
            <label class="fw-500">Number of Passengers</label>
            <input
              disabled
              type="text"
              class="form-control"
              placeholder="Number of Passengers"
              v-model="signature.number_of_guests"
            />
          </div>
          <div class="col">
            <label class="fw-500">Deposit Amount</label>
            <input
              disabled
              type="text"
              class="form-control"
              placeholder="Deposit Amount"
              v-model="signature.payment_amount"
            />
          </div>
        </div>
        <div class="row">
          <div class="col my-3">
            <label class="fw-500">Signature</label>
            <div class="signature-img px-4 py-4">
              <img v-if="signature.user_agent" width="300" alt="Signature" :src="signature.user_agent" />
              <img v-else src="/img/writing_signature.svg" width="10%" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'Signature',
  inheritAttrs: false,
  data () {
    return {
      signature: {
        id: null,
        parent: null,
        name: '',
        last_name: '',
        user_agent: '',
        payment_amount: '',
        local_datetime: moment().format('MMMM Do YYYY, h:mm:ss a'),
        traveler_email: '',
        number_of_guests: '',
        accepted_conditions: 1
      },
      isNotFound: false,
      isSearching: false
    }
  },
  computed: {
    ...mapGetters({
      getItinerarySignature: 'opportunity/getItinerarySignature'
    }),
    handleSignatureData () {
      return false
    },
    getIdItinerary () {
      if (this.data && this.data.itineraries) {
        this.searchItinerarySignature(this.data.itineraries[0].id)
      }
      return false
    }
  },
  props: {
    data: {
      validator: prop => typeof prop === 'object' || prop === null,
      required: true,
      default: () => {}
    },
    isEditingSignatureFunction: {
      type: Function,
      required: false
    },
    isEditingSignature: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    searchItinerarySignature (id) {
      this.isSearching = true
      return this.$store
        .dispatch('opportunity/searchSignature', id)
        .finally(() => {
          this.isSearching = false

          if (this.getItinerarySignature) {
            this.signature = this.getItinerarySignature[0]
            this.signature.parent = id
            return true
          }
        })
    },
    handleEditSignature () {
      this.isSearching = true

      return this.$store
        .dispatch('opportunity/processSignature', this.signature)
        .then(response => {
          if (response.id && response.message === 'OK') {
            return this.getIdItinerary
          }
        })
        .finally(() => {
          this.isEditingSignatureFunction()
          this.isSearching = false
        })
    }
  }
}
</script>

<style lang="scss">
.h-100 .ck-content {
  height: 100px !important;
}
.h-150 .ck-content {
  height: 150px !important;
}
.h-200 .ck-content {
  height: 200px !important;
}
.h-250 .ck-content {
  height: 250px !important;
}
.h-300 .ck-content {
  height: 300px !important;
}
.h-350 .ck-content {
  height: 350px !important;
}
.signature {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: solid 1.5px #e0e3ea;
  border-top-left-radius: 7.5px;
  border-top-right-radius: 7.5px;
  border-bottom:none;
}

.signature-edit {
  border: solid 1.5px #e0e3ea;
  border-bottom-right-radius: 7.5px;
  border-bottom-left-radius: 7.5px;
}
.text-main:hover {
  text-decoration: none;
}
.rounded {
  border: solid 1px;
  border-radius: 50% !important;
  width: 30px;
  padding: 0.3rem;
  height: 30px;
}

.signature-img {
  text-align: center;
  background: #edf1f7;
}
</style>
